import cncGetGraphConfig from "./cncGetGraphConfig"
import ExtrutionGetGraphConfig from "./extrutionGetGraphConfig"
import injectionMouldingGetGraphConfig from "./injectionMouldingGetGraphConfig"
import punchPressGetGraphConfig from "./punchPressGetGraphConfig"

const getTemplateTypeGraphConfig = (graphId, type, meta = {}, templateType)=>{
 switch(templateType){
    case 1:
        return injectionMouldingGetGraphConfig(graphId, type, meta = {})
    case 2:
        return ExtrutionGetGraphConfig(graphId, type, meta = {})
    case 3:
        return punchPressGetGraphConfig(graphId, type, meta = {})
    case 4:
        return cncGetGraphConfig(graphId, type, meta = {})
 }
}
export default getTemplateTypeGraphConfig